import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ClientLayout from '../../components/client/ClientLayout';
import ClientOverview from './ClientOverview';
import ClientHistory from './ClientHistory';
import ClientProfile from './ClientProfile';

const ClientDashboard = () => {
  return (
    <ClientLayout>
      <Routes>
        <Route index element={<ClientOverview />} />
        <Route path="history" element={<ClientHistory />} />
        <Route path="profile" element={<ClientProfile />} />
      </Routes>
    </ClientLayout>
  );
};

export default ClientDashboard;